/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import {
    EnvironmentDeploymentType,
    EnvironmentInfo,
} from "../../rest/environment-info/environment-info.interfaces";

export interface EnvironmentFlags {
    isSharedSaasEnv: boolean;
    isStarTreeQCAvailable: boolean;
}

export const getEnvironmentFlags = (
    envInfo: EnvironmentInfo,
    isStarTreeQCAvailable: boolean
): EnvironmentFlags => {
    const isSharedSaasEnv =
        envInfo.STARTREE_DEPLOYMENT_TYPE === EnvironmentDeploymentType.STARTREE;

    return {
        isSharedSaasEnv,
        isStarTreeQCAvailable,
    };
};

export const getStarTreeCloudUrl = (): string | null => {
    const currentOrigin = window.location.origin;
    if (
        currentOrigin.includes("localhost") ||
        currentOrigin.includes("startree-dev.cloud")
    ) {
        return "https://startree-dev.cloud";
    }

    if (currentOrigin.includes("startree-staging.cloud")) {
        return "https://startree-staging.cloud";
    }

    if (currentOrigin.includes("startree.cloud")) {
        return "https://startree.cloud";
    }

    return null;
};
